function checkAndExecute() {
    if (document.getElementById("ak-wrap-top-pin-product-history")) {
        recentlyViewed();
    } else {
        setTimeout(recentlyViewed, 5000); // Wait for 3 seconds before executing recentlyViewed
    }
}
function recentlyViewed() {
    var recentlyViewedAppSection = document.getElementById("ak-wrap-top-pin-product-history");
    var productRecommendations = document.querySelector(".product-recommendations-section");
    if (recentlyViewedAppSection && productRecommendations) {
        productRecommendations.appendChild(recentlyViewedAppSection); 
    }
}
checkAndExecute(); // Initial check

if(document.querySelector('.site-header-menu-toggle')){burgerToggle();}
if(document.querySelector('.fadeout_animate')){fadeOutEffect();}

function burgerToggle(){
    var burgerIcon = document.querySelector(".site-header-menu-toggle");
    var menuDrawer = document.getElementById("Details-menu-drawer-container");
    var headerMega = document.querySelector(".header-mega");

    burgerIcon.addEventListener("click", function(event){
        burgerIcon.classList.toggle("active");
        menuDrawer.classList.toggle("menu-opening");
        headerMega.classList.toggle("active");
        if(headerMega.classList.contains("fade-out")){
            headerMega.classList.remove("fade-out");
        }else{
            headerMega.classList.add("fade-out");
        }
    });
}

function fadeOutEffect(){
    var el = document.querySelector(".fadeout_animate");
    var elclick = document.querySelector(".fadeout_animate_click");

    elclick.addEventListener('click', function() {
        if(el.classList.contains("fade--out")){
            el.classList.remove("fade--out");
        }else{
            el.classList.add("fade--out");
        }
    });
}

const footerSubscribe = document.querySelector(".subs_trigger");
const newsLetterField = document.getElementById("NewsletterForm--footer");
if(document.querySelector(".subs_trigger") !== null){
    footerSubscribe.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
    
        if( isEmailValid(newsLetterField.value.toLowerCase()) ){
            sessionStorage.setItem('newsletterEmail', newsLetterField.value);
            const getnewsLetterEmail = sessionStorage.getItem("newsletterEmail")
            window.location.href = "https://olliesplace.com.au/pages/subsribe-to-ollies-friends#form_1_active";
            document.querySelector(".err_inp_msg").classList.remove("active");
        }else{
            document.querySelector(".err_inp_msg").classList.add("active");
        }
    });
}
function isEmailValid(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}

const getCurrentUrlPath = window.location.href;
const newsLetterFieldInPage = document.querySelector(".email_pull_from_session"); 
const activeCampaignNameFld = document.querySelector("._form_1 #fullname"); 
const activeCampaignEmailFld = document.querySelector("._form_1 #email"); 
const activeCampaignEmailForm1 = document.querySelector("._form_1"); 

if(typeof(activeCampaignEmailForm1) != 'undefined' && activeCampaignEmailForm1 != null){ 
    const getnewsLetterEmail = sessionStorage.getItem("newsletterEmail");
    activeCampaignEmailFld.value = getnewsLetterEmail;
}
if(document.querySelector(".subs_email_trigger") !== null){
    const emailSubscribe = document.querySelector(".subs_email_trigger");
    emailSubscribe.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        window.location.href = "#form_1_active";
        activeCampaignNameFld.focus();
    });
}

if(document.querySelector(".cstm_clss") !== null){ var parentElement = document.querySelector(".cstm_clss").parentElement; parentElement.classList.add("cstm_clss_parent");}

(function($){

    if($('.collapse-tab')){collapsibleTab();}
    if($('.true-cleartop')){clearTop();}
    if($('.turnoff_activecampaign_defaultstyle')){turnOffActiveCampaignStyles();}

    function turnOffActiveCampaignStyles(){
        var target = $('.turnoff_activecampaign_defaultstyle');
        target.find('form').removeClass('_inline-style _form _dark');
        target.find('form ._submit').addClass('btn_submit');
        target.find('form ._submit').removeClass('_submit');
        $('.form_style_new form .btn_submit').text("SIGN UP");
    }

    function clearTop(){
        var clearTop = $('.true-cleartop');
        clearTop.parents('section').addClass('clear-top');
    }

    function collapsibleTab(){
        //.collapse-tab collapse tab feature class
        //.collaps-body collapse body tab 
        var opener = $(".opener");
        var arrowIcon = $(".arrow-icon");
        opener.on('click', function(){
            var item = $(this).parents('.collapse-item-wrapper');
            if(!item.hasClass('active')){
                $('.collapse-item-wrapper').removeClass('active');
                $('.arrow-icon').removeClass('active');
                item.addClass('active');
                item.find('.arrow-icon').addClass("active");
            }else{
                item.removeClass('active');
                item.find('.arrow-icon').removeClass("active");
            }
        });
    }

    $(document).ready(function(){

        if ($("#main-cart-footer").length) {
            $("#main-cart-footer").closest(".shopify-section").addClass("has-main-cart-footer");
        }

        if ($("#judgeme_product_reviews").length) {
            $("#judgeme_product_reviews").closest("section").addClass("has-judgeme-reviews");
        }

        //Home Ollies friend form
        /*
        if($('.template_index ._form_1').length){ $('._form_1 ._button-wrapper button').text("SIGN UP");}
        $('.template_index ._form-content').prepend('<div class="js_prepended_items"><div class="left_elem"></div><div class="right_elem"></div></div>');
        $('.template_index .left_elem').prepend($('#phone').parents('._form_element'));
        $('.template_index .left_elem').prepend($('#email').parents('._form_element'));
        $('.template_index .left_elem').prepend($('#fullname').parents('._form_element'));
        $('.template_index .right_elem').prepend($('input[data-name="childs_age_group"]').parents('._form_element'));
        $('.template_index .right_elem').prepend($('select[data-name="childs_gender"]').parents('._form_element'));
        $('.template_index .js_prepended_items').after($('._button-wrapper'));
        */

        //pages/subsribe-to-ollies-friends
        if($('.template_page_subscriber ._form_1').length){ $('._form_1 ._button-wrapper button').text("SIGN UP");}
        $('.template_page_subscriber ._form-content').prepend('<div class="js_prepended_items"><div class="left_elem"></div><div class="right_elem"></div></div>');
        $('.template_page_subscriber .left_elem').prepend($('#phone').parents('._form_element'));
        $('.template_page_subscriber .left_elem').prepend($('#email').parents('._form_element'));
        $('.template_page_subscriber .left_elem').prepend($('#fullname').parents('._form_element'));
        $('.template_page_subscriber .right_elem').prepend($('input[data-name="childs_age_group"]').parents('._form_element'));
        $('.template_page_subscriber .right_elem').prepend($('select[data-name="childs_gender"]').parents('._form_element'));
        $('.template_page_subscriber .js_prepended_items').after($('._button-wrapper'));

        if($('.faqs-category').length){
            $('.faqs-category').on('click', function(){
                var $this = $(this),
                categoryData = $this.data('faqcategory');
                $this.toggleClass('active');
                $this.parents('.faq-list').find('.faqs-category.active').not(this).removeClass('active');
                $this.parents('.faq-list').find('.' + categoryData).toggleClass('active');
                $this.parents('.faq-list').find('.' + categoryData).first().find('.answ_bx').removeClass('faqs_hide');
                $this.parents('.faq-list').find('.faqs_item.active').not('.' + categoryData).removeClass('active');
                $this.parents('.faq-list').find('.' + categoryData).last().addClass('last-faq-item');
            });   
        }
        if($('.question_bx').length){
            $('.question_bx').on('click', function(){
                var $this = $(this),
                parent = $this.parents('.faqs_item'), 
                body = $('.answ_bx'), 
                faqsHide = 'faqs_hide';
                parent.siblings('.faqs_item').find(body).addClass(faqsHide);
                $('.question_bx').removeClass("active");
                var itemFaq = parent.find(body);
                if(itemFaq.hasClass(faqsHide)){
                    itemFaq.removeClass(faqsHide);
                    $this.addClass("active");
                }else{
                    itemFaq.addClass(faqsHide);
                    $this.removeClass("active");
                }
            });   
        }
    
        //Cart title shifting on top of free shipping card
        // const interval = setInterval(function() {
        //     if ($('.free_shipping_card').length) {
        //         $('.title-wrapper-with-link').insertBefore('.free_shipping_card');
        //       clearInterval(interval); // Stop checking once the element is found and moved
        //     }
        // }, 500);
    
        //Wrap Sku & Reviews stars in one row
        if ($("#shopify-block-AZFkxcGxOZzBPRytGb__judge_me_reviews_preview_badge_YwxkTM").length > 0 && $("#psku").length > 0) {
            var newDiv = $("<div>", { class: "custom-wrapper" });
            $("#shopify-block-AZFkxcGxOZzBPRytGb__judge_me_reviews_preview_badge_YwxkTM, #psku").wrapAll(newDiv);
        }

    });
    
    if($(".carousel-list").length){
        $(".carousel-list").slick({
            dots: false,
            autoplay: true,
            autoplaySpeed: 500,
            infinite: false,
            speed: 8000,
            slide: '.slide',
            cssEase: 'linear',
            "slidesToShow": 4,
            "slidesToScroll": 1,
            arrows: false,
            responsive: [
                {
                    breakpoint: 4000,
                        settings: {
                            slidesToShow: 5,
                            infinite: true,
                            dots: false,
                        }
                }, {
                    breakpoint: 2500,
                        settings: {
                            slidesToShow: 5,
                            infinite: true,
                            dots: false,
                        }
                }, {
                    breakpoint: 2000,
                        settings: {
                            slidesToShow: 5,
                            infinite: true,
                            dots: false,
                        }
                }, {
                    breakpoint: 1500,
                        settings: {
                            slidesToShow: 5,
                            infinite: true,
                            dots: false,
                        }
                }, {
                breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        infinite: true,
                        dots: false,
                    }
                }, {
                    breakpoint: 800,
                        settings: {
                            slidesToShow: 2,
                            autoplay: true,
                            dots: false,
                        }
                }, {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        dots: true,
                        dots: false,
                    }
                }, {
                    breakpoint: 300,
                    settings: {
                        slidesToShow: 1,
                        dots: false,
                        autoplay: true
                    }
                }]
        });
        $(".cstm_clss").removeClass('loading');
    }

})(jQuery);